// NB! add some HTML sanitization  here
// (+ markdown parsing)



export const parseHTML = (rawData) => {
    return {__html: rawData}
}